import type { FC } from 'react';
import { cloneElement, useEffect } from 'react';
import { useFormState, useForm } from 'react-final-form';

import type { TFormResetterProps } from './models';

const defaultExcludeFields = ['businessUid'];
// Виджет, который очищает поля формы. Пробегается по fields и контексту
export const FormResetter: FC<TFormResetterProps> = ({
    children,
    trigger = 'onClick',
    excludeFields = [],
    clearAllFields = false,
    ...rest
}) => {
    const onTrigger = rest[trigger];
    /** Убираем дубли если они есть и добавляем дефолтные исключения из reset */
    const unitedExcludeFields = Array.from(new Set([...excludeFields, ...defaultExcludeFields]));

    const { values } = useFormState({
        subscription: {
            values: true,
        },
    });
    const formApi = useForm();
    const { initialValues } = formApi.getState();

    const handleReset = () => {
        const allFields = clearAllFields ? values : {};

        const fieldsToReset = { ...initialValues, ...allFields };

        // Чистим поля
        Object.keys(fieldsToReset).forEach((field: string) => {
            // Игнорируем, так как businessUid относится к пользователю/сессии и его не нужно очищать
            if (!unitedExcludeFields.includes(field)) {
                formApi.change(field, '');
            }
        });

        if (clearAllFields) {
            const initValues = Object.entries(fieldsToReset)
                .filter(([key]) => unitedExcludeFields.includes(key))
                .reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {});

            formApi.initialize(initValues);
        }
    };

    useEffect(() => {
        if (!children) handleReset();

        // выполняется только на монтирование
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleTrigger = (event: MouseEvent) => {
        handleReset();

        if (typeof onTrigger === 'function') {
            onTrigger(event);
        }
    };

    if (!children) {
        return null;
    }

    return cloneElement(children, {
        [trigger]: handleTrigger,
    });
};
